import React from 'react';

const Stepper = ({ steps, currentStep }) => {
  return (
    <div className="stepper-wrapper">
      {steps.map((step, index) => (
        <div 
          key={index} 
          className={`stepper-item ${currentStep > index + 1 ? 'completed' : ''} ${currentStep === index + 1 ? 'active' : ''}`}
        >
          <div className="step-counter">
            {currentStep > index + 1 ? (
              <i className="bi bi-check-circle-fill"></i>
            ) : (
              index + 1
            )}
          </div>
          <div className="step-name">{step.title}</div>
        </div>
      ))}
    </div>
  );
};

export default Stepper;